import UserActions from "./UserActions";
import {
  ADD_REFERENCE_PAGE,
  APPLICATION_SUMMERY_PAGE,
  BANKID_PAGE,
  PRIMARY_APPLICATION_SUMMERY_PAGE,
  QUESTIONAIRE_PAGE,
  SCHEDULE_INTERVIEW,
  SECONDARY_APPLICATION_SUMMERY_PAGE,
  SELECT_SYSTEM_KNOWLEDGE_PAGE,
  UPLOAD_CPR_CERT_PAGE,
  UPLOAD_CRIMINAL_RECORD_PAGE,
  UPLOAD_CV_PAGE,
  UPLOAD_ID_CARD_PAGE,
} from "./jobApplicationProcessSteps";

export const INLINE_APPLICATION_CONTACT_STEP_ID = "inline-application-contact";
export const INLINE_APPLICATION_STEP_COUNT = 1;

export const APPLICATION_STEP_VIEWED_ACTIONS = Object.freeze({
  [QUESTIONAIRE_PAGE]: UserActions.application_answer_questionaire,
  [APPLICATION_SUMMERY_PAGE]: UserActions.application_summary,
  [BANKID_PAGE]: UserActions.application_bankid_auth,
  [UPLOAD_CV_PAGE]: UserActions.application_upload_cv,
  [ADD_REFERENCE_PAGE]: UserActions.application_add_reference,
  [SELECT_SYSTEM_KNOWLEDGE_PAGE]: UserActions.application_select_system_knowledge,
  [SCHEDULE_INTERVIEW]: UserActions.application_book_interview,
  [PRIMARY_APPLICATION_SUMMERY_PAGE]: UserActions.application_primary_summary,
  [UPLOAD_ID_CARD_PAGE]: UserActions.application_upload_id_card,
  [UPLOAD_CPR_CERT_PAGE]: UserActions.application_upload_cpr_certificate,
  [UPLOAD_CRIMINAL_RECORD_PAGE]: UserActions.application_upload_criminal_record,
  [SECONDARY_APPLICATION_SUMMERY_PAGE]: UserActions.application_secondary_summary,
});

export const getApplicationStepViewedAction = (pageId) =>
  APPLICATION_STEP_VIEWED_ACTIONS[pageId] || pageId;

export const getApplicationStepName = (pageId) =>
  getApplicationStepViewedAction(pageId);

export const getApplicationStepIndex = (page, pages = [], offset = 0) => {
  if (!page?.id) return null;

  const index = pages.findIndex((item) => item.id === page.id);
  return index >= 0 ? index + 1 + offset : null;
};

export const getOrCreateApplicationSessionId = (jobId) => {
  if (!jobId || typeof window === "undefined") return null;

  const storageKey = `application-session.${jobId}`;
  const existing = window.sessionStorage?.getItem(storageKey);
  if (existing) return existing;

  const sessionId =
    window.crypto?.randomUUID?.() ??
    `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
  window.sessionStorage?.setItem(storageKey, sessionId);
  return sessionId;
};

export const buildApplicationStepPayload = ({
  page,
  pages,
  jobData,
  source,
  contactPerson,
  sessionId,
}) => {
  const workplaceDetails =
    jobData?.healthcareWorkplaceDetails ?? jobData?.workplaceDetails ?? {};

  return {
    application_session_id: sessionId,
    application_step_id: page?.id || null,
    application_step_name: page?.id ? getApplicationStepName(page.id) : null,
    application_step_label: page?.title || null,
    application_step_type: page?.type || null,
    application_step_index: getApplicationStepIndex(
      page,
      pages,
      INLINE_APPLICATION_STEP_COUNT,
    ),
    application_total_steps: pages.length + INLINE_APPLICATION_STEP_COUNT,
    job_title: jobData?.profession || jobData?.title || null,
    job_profession: jobData?.profession || null,
    workplace_name:
      workplaceDetails?.nameVerksamhet || workplaceDetails?.name || null,
    workplace_city: workplaceDetails?.city || null,
    workplace_municipality: workplaceDetails?.municipality || null,
    application_source: source,
    contact_person_id: contactPerson?.userId || null,
    contact_person_workplace_id: contactPerson?.workplaceId || null,
  };
};
